// extracted by mini-css-extract-plugin
export default {"containerHeader":"NotificationTable_containerHeader__8QQjr","headerRight":"NotificationTable_headerRight__ZpCyz","headerLeft":"NotificationTable_headerLeft__yl8-i"};